import { createStore } from '@ngneat/elf'
import {
  addEntities,
  deleteEntities,
  getAllEntitiesApply,
  selectAllEntities,
  upsertEntities,
  withEntities,
} from '@ngneat/elf-entities'
import { Injectable } from '@angular/core'
import { BlacklistArticleModel, CreateBlacklistArticleParams } from '../../generated/efp-api'
import { BlacklistArticleDao } from '../services/dao/blacklist-article.dao'
import { Doka360ProjectSelectorService } from '../services/doka360-project-selector.service'

const blacklistArticlesStore = createStore(
  { name: 'blacklistArticles' },
  withEntities<BlacklistArticleModel>()
)

@Injectable({
  providedIn: 'root',
})
export class BlacklistArticleRepository {
  public readonly articles$ = blacklistArticlesStore.pipe(selectAllEntities())

  constructor(
    private readonly blacklistArticleDao: BlacklistArticleDao,
    private readonly doka360ProjectSelectorService: Doka360ProjectSelectorService
  ) {}

  public async create(favoriteId: number, articles: CreateBlacklistArticleParams[]): Promise<void> {
    const createdArticles = await this.blacklistArticleDao.createArticles(favoriteId, articles)
    blacklistArticlesStore.update(addEntities(createdArticles))
    return
  }

  public async delete(article: BlacklistArticleModel): Promise<void> {
    await this.blacklistArticleDao.delete(article.id)
    blacklistArticlesStore.update(deleteEntities(article.id))
  }

  public async findAllByFavouriteProfileId(
    favouriteProfileId: number
  ): Promise<BlacklistArticleModel[]> {
    let articles = blacklistArticlesStore.query(
      getAllEntitiesApply({
        filterEntity: (e) => e.favouriteProfileId === favouriteProfileId,
      })
    )

    if (!articles || articles.length === 0) {
      const currentDoka360ProjectUid =
        this.doka360ProjectSelectorService.getCurrentDoka360ProjectUid()
      articles = await this.blacklistArticleDao.findAllByFavouriteProfileId(
        favouriteProfileId,
        currentDoka360ProjectUid
      )
      blacklistArticlesStore.update(upsertEntities(articles))
    }

    return articles
  }
}
